var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1236 15.5628C19.7217 16.6459 18.9709 17.9998 17.7762 17.9998H2.22431C1.02727 17.9998 0.279895 16.6438 0.876904 15.5628L8.65293 1.4785C9.2514 0.394858 10.7503 0.396822 11.3477 1.4785L19.1236 15.5628V15.5628ZM10.0003 12.6509C9.17702 12.6509 8.50959 13.3481 8.50959 14.2082C8.50959 15.0682 9.17702 15.7655 10.0003 15.7655C10.8236 15.7655 11.4911 15.0682 11.4911 14.2082C11.4911 13.3481 10.8236 12.6509 10.0003 12.6509ZM8.585 7.05323L8.8254 11.6574C8.83665 11.8728 9.00717 12.0415 9.21371 12.0415H10.787C10.9935 12.0415 11.164 11.8728 11.1753 11.6574L11.4157 7.05323C11.4278 6.82051 11.2504 6.62484 11.0274 6.62484H8.97328C8.75018 6.62484 8.57285 6.82051 8.585 7.05323V7.05323Z",
    fill: "#FF4753"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.aef240084c475300153c63463fe3a18b.svg";
export { ForwardRef as ReactComponent };